<template>
  <div class="container-list">
    <div class="flex">
      <!-- <unitList @select="getUnit" @getFirst="getOne"></unitList> -->
      <!-- <unitList

       v-show="!($store.state.user.userInfo.natureId==2)"

        @select="getUnit"
        @getFirst="getOne"
      ></unitList> -->
      <div class="flex1">
        <div class="common-page common-head">
          <div class="common-page common-head-title">
            <i class="icon-tr--detailed" style="padding-right: 5px"></i>
            文物档案
          </div>
          <!-- <div class="common-page common-head-end">
                <i class="icon-tr-sign-out"></i>
      </div>-->
        </div>
        <div class="common-page common-body">
          <div
            class="common-page common-tool-bar"
            style="justify-content: space-between"
          >
            <div class="flex ml20">
              <div class="ml20 nowBox">
                <div style="color:#3d62de;font-size:18px">
                  <p>在册</p>
                  <p>{{ total }}</p>
                </div>
              </div>
              <div class="ml20 nowBox">
                <div style="color:#3d62de;font-size:18px">
                  <p>待审核</p>
                  <p>{{ msg }}</p>
                </div>
              </div>
            </div>
            <div class="flex">
              <!-- v-hasPermi="['culturalRelics:wenwuBasicInformation:list']" -->
              <div class="ml20" @click="showDia = true">
                <el-button icon="el-icon-search" type="primary">查询</el-button>
              </div>
              <!-- v-hasPermi="['culturalRelics:wenwuBasicInformation:export']" -->
              <div class="ml20" @click="output">
                <el-button type="success" v-hasPermi="['archives:relicInspectionArchives:export']">导出</el-button>
              </div>
              <!-- type:  0 只查看  1 可编辑   page:0 演练记录 1 灭火记录  -->

              <!-- v-hasPermi="['wenwu:fileindex:add']" -->

              <router-link
                class="ml20"
                v-hasPermi="['archives:relicInspectionArchives:addAndUpdate']"
                :to="{
                  path: '/wenlv/relicFilesAdd',
                  query: { type: 1, page: 1 },
                }"
                ><el-button type="primary">新增</el-button></router-link
              >
            </div>
          </div>
          <div class="common-page common-list">
            <el-table :data="list" class="">
              <el-table-column
                prop="serialNo"
                label="序号"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="relicName"
                label="文物名称"
                align="center"
              ></el-table-column>
              <el-table-column label="文物类别" align="center">
                <template scope="scope">
                  <div v-if="scope.row.type == 1">古建筑</div>
                  <div v-else-if="scope.row.type == 2">
                    近现代重要史迹及代表性建筑
                  </div>
                  <div v-else-if="scope.row.type == 3">古墓葬</div>
                  <div v-else-if="scope.row.type == 4">石窟寺及石刻</div>
                  <div v-else-if="scope.row.type == 5">古遗址</div>
                  <div v-else-if="scope.row.type == 6">其它</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="position"
                align="center"
                label="文物位置"
              ></el-table-column>

              <!-- <el-table-column
            prop="m_rate"
            align="center"
            label="巡查频次"
          ></el-table-column> -->

              <el-table-column
                prop="age"
                align="center"
                label="文物年代"
              ></el-table-column>

              <el-table-column prop="relicRank" align="center" label="级别">
                <template scope="scope">
                  <div v-if="scope.row.relicRank == 1">全国重点</div>
                  <div v-else-if="scope.row.relicRank == 2">省级</div>
                  <div v-else-if="scope.row.relicRank == 3">青岛市级</div>
                  <div v-else-if="scope.row.relicRank == 4">平度市级</div>
                  <div v-else-if="scope.row.relicRank == 5">尚未定级</div>
                </template>
              </el-table-column>
              <el-table-column prop="status" align="center" label="状态">
                <template slot-scope="scope">
                  <div v-if="scope.row.status == 0">
                    审核中
                  </div>
                  <div v-else-if="scope.row.status == 1">
                    通过
                  </div>
                  <div v-else-if="scope.row.status == 2">
                    驳回
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                label="操作"
                align="center"
                width="180px"
                fixed="right"
              >
                <template slot-scope="scope">
                  <router-link
                  v-hasPermi="['archives:relicInspectionArchives:getInfo']"
                    :to="{
                      path: '/wenlv/relicFilesAdd',
                      query: { id: scope.row.id, view: true },
                    }"
                  >
                    <el-button type="primary" size="mini">查看</el-button>
                  </router-link>
                 
                  <!-- v-hasPermi="['culturalRelics:wenwuBasicInformation:edit']" -->
                  <router-link
                  v-hasPermi="['archives:relicInspectionArchives:addAndUpdate']"
                    :to="{
                      path: '/wenlv/relicFilesAdd',
                      query: { id: scope.row.id },
                    }"
                  >
                    <el-button type="warning" size="mini">修改</el-button>
                  </router-link>
                  <div style="display:inline-block">
                     <el-popconfirm
                    title="确定删除此项吗？"
                    class="cursor"
                    @onConfirm="changeStatus(scope.row.id, 2)"
                    @confirm="changeStatus(scope.row.id, 2)"
                  >
                    <a slot="reference">
                      <el-button v-hasPermi="['archives:relicInspectionArchives:remove']" type="danger" size="mini">删除</el-button>
                    </a>
                  </el-popconfirm>
                  </div>
                 <div style="display:inline-block">
                    <el-popconfirm
                    title="是否通过该档案？"
                    class="cursor"
                    @onConfirm="filePass(scope.row.id, 2)"
                    @confirm="filePass(scope.row.id, 2)"
                  >
                    <a slot="reference" v-show="scope.row.status==0" >
                      <el-button v-hasPermi="['archives:relicInspectionArchives:pass']" type="success" size="mini" style="margin-top:5px">通过</el-button>
                    </a>
                  </el-popconfirm>
                 </div>
                 

                  <el-button
                    type="info"
                    size="mini"
                    v-show="scope.row.status==0"
                    @click="bohuiClick(scope.row.id)"
                    v-hasPermi="['archives:relicInspectionArchives:turnDown']"
                    >驳回</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="pageChange"
            :page-size="10"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      title=""
      :visible.sync="showDilog1"
      :close-on-click-modal="false"
    >
      <div style="height:200px">
        <h3>是否驳回该档案？</h3>
        <el-form
          ref="formbohui"
          :model="formbohui"
          :rules="rules1"
          class="mt20"
        >
          <el-form-item label="请填写驳回理由" prop="turnDown">
            <el-input
              v-model="formbohui.turnDown"
              type="textarea"
              :rows="3"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="center">
        <el-button @click="cancelFile()" size="small">取消</el-button>
        <el-button type="primary" @click="searchSubmitFile" size="small"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="查询"
      :visible.sync="showDia"
      :close-on-click-modal="false"
    >
      <!-- <fm-generate-form
        :data="searchForm"
        :remote="remoteFuncs"
        :value="editData"
        ref="searchForm"
      ></fm-generate-form> -->
      <el-form ref="form" :model="form" label-width="110px">
        <el-form-item label="文物" prop="login_pass">
          <el-input v-model="form.relicName"></el-input>
        </el-form-item>
        <el-row v-if="$store.state.user.userInfo.natureId != 2">
          <el-col>
            <el-form-item label="单位" prop="companyNum" style="width: 100%">
              <el-select v-model="form.companyNum">
                <el-option
                  v-for="item in chanxunform1Com"
                  :value="item.ccompanyNum"
                  :label="item.cname"
                ></el-option>
                <!-- <el-option value="1" label="通过"></el-option>
                <el-option value="2" label="驳回"></el-option> -->
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="文物类别" prop="type" style="width: 100%">
              <el-select v-model="form.type">
                <el-option :value="1" label="古建筑"></el-option>
                <el-option
                  :value="2"
                  label="近现代重要史迹及代表性建筑"
                ></el-option>
                <el-option :value="3" label="古墓葬"></el-option>
                <el-option :value="4" label="石窟寺及石刻"></el-option>
                <el-option :value="5" label="古遗址"></el-option>
                <el-option :value="6" label="其它"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="级别" prop="relicRank" style="width: 100%">
              <el-select v-model="form.relicRank">
                <el-option :value="1" label="全国重点"></el-option>
                <el-option :value="2" label="省级"></el-option>
                <el-option :value="3" label="青岛市级"></el-option>
                <el-option :value="4" label="平度市级"></el-option>
                <el-option :value="5" label="尚未定级"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="状态" prop="status" style="width: 100%">
              <el-select v-model="form.status">
                <el-option :value="0" label="审核中"></el-option>
                <el-option :value="1" label="通过"></el-option>
                <el-option :value="2" label="驳回"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- <el-form-item
          label="开始时间:"
          prop=""
          style="width: 100%"
          class="flex1"
        >
          <el-date-picker
            v-model="form.startDate"
            type="date"
            placeholder="选择日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd 00:00:00"
          >
          </el-date-picker>
        </el-form-item> -->
        <!-- 
        <el-form-item
          label="结束时间:"
          prop=""
          style="width: 100%"
          class="flex1"
        >
          <el-date-picker
            v-model="form.endDate"
            type="date"
            placeholder="选择日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd 00:00:00"
          >
          </el-date-picker>
        </el-form-item> -->

        <!-- <div class="btn-box">
          <div class="l-btn" @click="onSubmit">保存</div>
          <div class="l-btn ml20" @click="$router.back()">返回</div>
        </div> -->
      </el-form>

      <div class="center">
        <el-button type="primary" @click="searchSubmit" size="small"
          >确定</el-button
        >
        <el-button @click="cancle" size="small">重置</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import unitList from "@/components/unitList";
import qs from "qs";

export default {
  components: {
    unitList,
  },
  data() {
    return {
      cpNum: "",
      list: [],
      groups: [],
      params: {
        pageNum: 1,
        pageSize: 10,

        // company_num: this.cpNum || this.$store.state.user.company.cCompanyNum,
      },
      form: {
        status: null,
        companyNum: "",
        relicRank: null,
      },
      formbohui: {
        turnDown: null,
      },
      chanxunform1Com: null,
      rules1: {
        turnDown: {
          message: "请填写/选择",
          trigger: "change",
          required: true,
        },
      },
      messForm: {
        type: "",
        addr: "",
        ess: "",
        person: [],
      },
      people: [],
      select2: [],
      units: [],
      total: 0, // 总数
      msg: 0, // 总数
      showDia: false, // 查询
      checkAll: false, //选择全部
      showDia1: false, // 下发短信
      searchForm: this.$getForm("safePlace"),
      editData: {},
      remoteFuncs: {},
      showDilog1: false,
      bohuiId: null,
    };
  },
  created() {
    this.getList();
    // 单拉下拉框
    this.getCom();
  },
  components: { unitList },
  methods: {
    bohuiClick(id) {
      this.bohuiId = id;
      this.formbohui.turnDown=null
      this.showDilog1 = true;
    },
    getCom() {
      this.$get("/relic/relicInspectionArchives/companyInfoByUser").then(
        (res) => {
          // log(res, 33333333);
          this.chanxunform1Com = res.data;
        }
      );
    },
    cancelFile() {
      this.showDilog1 = false;
    },
    searchSubmitFile() {
      console.log(this.formbohui)
      this.$refs.formbohui.validate((valid) => {
        console.log(valid);
        if (valid) {
          console.log("验证");
          this.formbohui.id = this.bohuiId;
           this.$put('/relic/relicInspectionArchives/turnDown',this.formbohui).then(res=>{
            console.log(res,'BOHUI');
            this.$message({ message: res.msg, type: "success", duration: 700 });
            this.getList()
           })
           this.showDilog1=false
        } else {
          return false;
        }
      });
    },
    //    getOne(v){
    //      this.cpNum = v
    //  },
    //  getUnit(v){
    //      this.cpNum = v
    //  },
    filePass(it) {
      console.log(it);
      this.$put("/relic/relicInspectionArchives/pass" ,{id:it} ).then((res) => {
        console.log(res);
        this.$message({ message: res.msg, type: "success", duration: 700 });
        this.getList()
      });
    },
    //导出
    output() {
      this.$get("/relic/relicInspectionArchives/export", this.params).then(
        (res) => {
          // console.log(res,this.download)
          this.download(res.msg);
        }
      );
      // this.downLoadExcel(
      //   "/culturalRelics/wenwuBasicInformation/export",
      //   this.params
      // );
    },
    changetower(val, index) {
      this.units.map((item, index) => {
        if (item.dueng === val) {
          this.select2 = item.ceng;
        }
      });
    },
    handleCheckAllChange(val) {
      this.people = val ? this.groups : [];
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.groups.length;
    },
    changeStatus(it) {
      console.log(it);
      this.$remove("/relic/relicInspectionArchives/" + it).then((res) => {
        this.$message({ message: res.msg, type: "success", duration: 700 });
        this.getList();
      });
    },
    cancle() {
      this.resetSearch();
      this.getList();
      // this.showDia = false;
    },

    // 生成二维码
    //  跳转添加
    link() {
      this.$route.push("/plan/drill-add");
    },

    getList() {
      this.$get("/relic/relicInspectionArchives/list", this.params).then(
        (res) => {
          // console.log(res, 111111111);
          this.list = res.rows;
          this.total = res.total;
          this.msg = res.msg;
        }
      );
    },
    //  getList1(){
    //         this.$post('/score/maintenancelist',this.params).then(res=>{
    //           this.list = res.data.list
    //           this.count = res.count
    //   })
    //   },
    pageChange(val) {
      this.params.pageNum = val;
      this.getList();
    },
    searchSubmit() {
      console.log(this.form);
      this.params = { ...this.params, ...this.form };
      this.params.pageNum = 1;
      this.getList();
      this.showDia = false;

      //  打印
    },
    resetSearch() {
      this.form = {
        buildName: "",
        startDate: "",
        endDate: "",
      };
      this.params = {
        buildName: "",
        startDate: "",
        endDate: "",
        pageNum: 1,
        pageSize: 10,
        company_num: this.cpNum || this.$store.state.user.company.cCompanyNum,
      };
    },
    // getOne(val) {
    //   this.params.c_company_num = val;
    //   this.getList()
    // },
    // getUnit(val) {
    //   this.params.c_company_num = val;
    //   this.getList()

    // },
  },
  // beforeRouteEnter(to, from, next) {
  //           console.log(from)
  //   next(vm => {
  //     if(from.name==='/plan-add'){
  //       vm.getList()
  //     }

  //     console.log(vm);
  //   });
  // },
  watch: {
    cpNum() {
      this.params.company_num = this.cpNum;
      this.params.page = 1;
      this.$post("/drill/companytowetinfo", {
        c_company_num: this.params.company_num,
      }).then((res) => {
        this.units = res.data.list;
      });
      this.getList();
    },
  },
};
</script>

<style scoped>
.el-dialog .el-dialog__body {
  padding: 0 !important;
}
.nowBox {
  width: 200px;
  height: 80px;
  background: rgba(238, 243, 254);
  border: 1px solid #3d62de;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
